import { Text } from './text.js'

export * from './text.js'

export default Text
